import React, { useEffect, useState } from 'react';
import { FaAddressBook } from 'react-icons/fa';
import { FaMailBulk } from 'react-icons/fa';
import { FaWhatsappSquare } from 'react-icons/fa';
import { FaPhoneSquareAlt } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaFacebookSquare } from 'react-icons/fa';
import { FaInstagramSquare } from 'react-icons/fa';
import $ from 'jquery';
import swal from 'sweetalert';
import axios from './axios-config';
import { usePais } from './context/PaisContext';
import { useAseguradora } from './context/AseguradoraContext';
import FOOTER_DATOS_POR_PAIS from './footerDatosPorPais';
import { obtenerContactenosPorIdPais } from './Servicios/contactenosService';
import { construirDatosFooterDesdeContactenos } from './contactenosParaFooter';

// Ícono por tipo de red social: agregar una red nueva es solo agregar una
// entrada aquí y usar ese "tipo" en footerDatosPorPais.js.
const ICONOS_POR_TIPO_RED = {
  instagram: FaInstagramSquare,
  facebook: FaFacebookSquare,
  linkedin: FaLinkedin,
  whatsapp: FaWhatsappSquare,
  web: FaAddressBook,
};

const TITULOS_SECCION = {
  servicioCliente: 'SERVICIO AL CLIENTE',
  redesSociales: 'REDES SOCIALES',
  newsletter: 'NEWSLETTER',
};

// Orden visual de las columnas (igual al diseño actual de GT).
const ORDEN_SECCIONES = ['servicioCliente', 'redesSociales', 'newsletter'];

const MENSAJE_REDES_POR_DEFECTO = 'Síguenos en nuestras redes sociales';

function textoVersion(versionApp) {
  return `Somit Corredores de Seguros S.A. 1990 - 2026 ${versionApp || ''}`.trim();
}

function suscribirNewsletter() {
  axios.post(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/contacto_nuevo/` + $('#email_input').val(), {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
    },
  }).then(json => {
    if (json.status === 200) {
      swal("Ingreso Exitoso", "Se ha almacenado correctamente tu correo", "success");
    } else {
      swal("Error", "No se pudo guardar", "warning");
    }
  }).catch(function (error) {
    swal("Error", "No ha ingresado", "warning");
  });
}

// ¿La sección tiene contenido para renderizar? (evita columnas/huecos vacíos
// si algún día una sección existe en los datos pero sin elementos).
function seccionTieneContenido(datos, clave) {
  const valor = datos[clave];
  if (!valor) return false;
  if (Array.isArray(valor)) return valor.length > 0;
  return true;
}

function IconoRedSocial({ tipo, size }) {
  const Icono = ICONOS_POR_TIPO_RED[tipo];
  if (!Icono) return null;
  return <Icono style={{ height: 'auto', color: '#FFFFFF' }} size={size} />;
}

// Diseño corporativo moderno para el footer "completo" (grilla): mismo
// degradado que el footer "destacado" (identidad visual única del
// componente), íconos en chips circulares, columnas separadas por
// divisores sutiles, títulos con acento en vez de línea completa, y CTAs
// tipo "pill". Deliberadamente NO usa la clase "app-footer" ni el grid de
// reactstrap — self-contained, igual que el footer "destacado", para no
// heredar reglas de App.css pensadas para el diseño anterior.
const ESTILO_COMPLETO_RESPONSIVE = `
  .app-footer-v2 .footer-fila-contacto:hover {
    color: #ffffff;
  }
  .app-footer-v2 .footer-fila-contacto:hover .footer-icono-chip {
    background-color: rgba(255,255,255,0.22);
    border-color: rgba(255,255,255,0.45);
  }
  .app-footer-v2 .footer-cta:hover {
    background-color: rgba(255,255,255,0.14);
    border-color: rgba(255,255,255,0.65);
  }
  .app-footer-v2 .footer-campo-input::placeholder {
    color: rgba(255,255,255,0.55);
  }
  .app-footer-v2 .footer-campo-input:focus {
    outline: none;
    border-color: rgba(255,255,255,0.6);
    background-color: rgba(255,255,255,0.16);
  }
  .app-footer-v2 .footer-columna:not(:first-child) {
    border-left: 1px solid rgba(255,255,255,0.14);
    padding-left: 40px;
  }
  @media (max-width: 767px) {
    .app-footer-v2 {
      padding: 32px 20px 20px !important;
    }
    .app-footer-v2 .footer-grid {
      grid-template-columns: 1fr !important;
      row-gap: 32px !important;
    }
    .app-footer-v2 .footer-columna:not(:first-child) {
      border-left: none;
      padding-left: 0;
      border-top: 1px solid rgba(255,255,255,0.14);
      padding-top: 28px;
    }
  }
`;

const ESTILOS_COMPLETO = {
  footer: {
    background: 'linear-gradient(135deg, #872434 0%, #5e1926 100%)',
    color: '#FFFFFF',
    padding: '52px 48px 28px',
  },
  contenedor: { maxWidth: '1180px', margin: '0 auto' },
  grid: { display: 'grid', gap: '40px', marginBottom: '36px' },
  tituloSeccion: {
    fontSize: '0.78rem',
    fontWeight: 700,
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.85)',
    margin: 0,
    marginBottom: '10px',
  },
  acento: {
    width: '32px',
    height: '3px',
    borderRadius: '2px',
    background: 'rgba(255,255,255,0.5)',
    marginBottom: '22px',
  },
  filaContacto: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: 'rgba(255,255,255,0.85)',
    textDecoration: 'none',
    marginBottom: '14px',
    fontSize: '0.92rem',
    lineHeight: 1.4,
    transition: 'color .15s ease',
  },
  iconoChip: {
    flex: '0 0 auto',
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.10)',
    border: '1px solid rgba(255,255,255,0.22)',
    transition: 'background-color .15s ease, border-color .15s ease',
  },
  cta: {
    display: 'inline-block',
    marginTop: '6px',
    padding: '9px 22px',
    borderRadius: '999px',
    border: '1.5px solid rgba(255,255,255,0.55)',
    background: 'transparent',
    color: '#FFFFFF',
    fontSize: '0.78rem',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'background-color .15s ease, border-color .15s ease',
  },
  textoNewsletter: {
    color: 'rgba(255,255,255,0.78)',
    fontSize: '0.88rem',
    lineHeight: 1.5,
    margin: 0,
    marginBottom: '18px',
  },
  campoInput: {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    background: 'rgba(255,255,255,0.10)',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: '10px',
    color: '#FFFFFF',
    padding: '11px 14px',
    fontSize: '0.9rem',
    marginBottom: '14px',
  },
  barraInferior: {
    borderTop: '1px solid rgba(255,255,255,0.16)',
    paddingTop: '20px',
    textAlign: 'center',
  },
  textoVersion: { color: 'rgba(255,255,255,0.65)', fontSize: '0.8rem', letterSpacing: '0.3px' },
};

function FilaContacto({ href, icono, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="footer-fila-contacto"
      style={ESTILOS_COMPLETO.filaContacto}
    >
      <span className="footer-icono-chip" style={ESTILOS_COMPLETO.iconoChip}>{icono}</span>
      <span>{children}</span>
    </a>
  );
}

function ContenidoServicioCliente({ datos }) {
  // Guards defensivos: esta sección puede venir de la API en vivo de
  // CONTACTENOS (ver contactenosParaFooter.js), que no siempre trae los
  // tres datos (ej. puede tener teléfonos pero no correo todavía).
  const mailtoHref = datos.correo
    ? (datos.correo.asunto
      ? `mailto:${datos.correo.direccion}?subject=${datos.correo.asunto}`
      : `mailto:${datos.correo.direccion}`)
    : null;

  return (
    <div>
      {datos.web && (
        <FilaContacto href={datos.web.url} icono={<FaAddressBook size="15px" />}>
          {datos.web.texto}
        </FilaContacto>
      )}
      {datos.telefonos.map((telefono, index) => (
        <FilaContacto key={index} href={`tel:${telefono.tel}`} icono={<FaPhoneSquareAlt size="15px" />}>
          {[telefono.etiqueta, telefono.numero].filter(Boolean).join(' ')}
        </FilaContacto>
      ))}
      {datos.correo && (
        <FilaContacto href={mailtoHref} icono={<FaMailBulk size="15px" />}>
          {datos.correo.direccion}
        </FilaContacto>
      )}
      {datos.cotizar && (
        <a
          href={datos.cotizar.url}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-cta"
          style={ESTILOS_COMPLETO.cta}
        >
          Cotizar
        </a>
      )}
    </div>
  );
}

function ContenidoNewsletter({ datos }) {
  return (
    <div>
      <p style={ESTILOS_COMPLETO.textoNewsletter}>{datos.texto}</p>
      <input
        id="email_input"
        name="email_input"
        type="email"
        placeholder="Ingresa tu correo"
        className="footer-campo-input"
        style={ESTILOS_COMPLETO.campoInput}
      />
      <button
        type="button"
        onClick={() => suscribirNewsletter()}
        className="footer-cta"
        style={{ ...ESTILOS_COMPLETO.cta, marginTop: 0 }}
      >
        Suscribirme
      </button>
    </div>
  );
}

function ContenidoRedesSociales({ redesSociales }) {
  return (
    <div>
      {redesSociales.map((red, index) => (
        <FilaContacto key={index} href={red.url} icono={<IconoRedSocial tipo={red.tipo} size="15px" />}>
          {red.usuario}
        </FilaContacto>
      ))}
    </div>
  );
}

const CONTENIDO_POR_SECCION = {
  servicioCliente: (datos) => <ContenidoServicioCliente datos={datos} />,
  newsletter: (datos) => <ContenidoNewsletter datos={datos} />,
  redesSociales: (datos) => <ContenidoRedesSociales redesSociales={datos} />,
};

// Footer "completo" (usado hoy por GT y, tras el login con póliza
// seleccionada, por CR): una columna por sección disponible, en una grilla
// CSS que se reacomoda sola según cuántas secciones haya (2 o 3 columnas en
// escritorio, 1 en móvil) — nunca deja una columna vacía o desproporcionada.
function FooterCompleto({ secciones, datos, versionApp }) {
  return (
    <footer className="app-footer-v2" style={ESTILOS_COMPLETO.footer}>
      <style>{ESTILO_COMPLETO_RESPONSIVE}</style>
      <div style={ESTILOS_COMPLETO.contenedor}>
        <div
          className="footer-grid"
          style={{ ...ESTILOS_COMPLETO.grid, gridTemplateColumns: `repeat(${secciones.length}, 1fr)` }}
        >
          {secciones.map((clave) => (
            <div key={clave} className="footer-columna">
              <h2 style={ESTILOS_COMPLETO.tituloSeccion}>{TITULOS_SECCION[clave]}</h2>
              <div style={ESTILOS_COMPLETO.acento}></div>
              {CONTENIDO_POR_SECCION[clave](datos[clave])}
            </div>
          ))}
        </div>
        <div style={ESTILOS_COMPLETO.barraInferior}>
          <span style={ESTILOS_COMPLETO.textoVersion}>{textoVersion(versionApp)}</span>
        </div>
      </div>
    </footer>
  );
}

// Estilos propios del footer "destacado": deliberadamente NO reutiliza la
// clase "app-footer" (esa trae reglas responsive de App.css afinadas para
// la grilla de GT, ej. fuerza los íconos svg a 22px en móvil) para que este
// diseño no dependa de ni se vea afectado por ajustes futuros a esa grilla.
const ESTILO_DESTACADO_RESPONSIVE = `
  .footer-redes-destacado .footer-icono-insignia:hover {
    transform: translateY(-4px);
    background-color: rgba(255,255,255,0.25);
  }
  @media (max-width: 480px) {
    .footer-redes-destacado {
      padding: 22px 16px 14px !important;
    }
    .footer-redes-destacado .footer-icono-insignia {
      width: 46px !important;
      height: 46px !important;
    }
    .footer-redes-destacado .footer-icono-insignia svg {
      width: 20px !important;
      height: 20px !important;
    }
    .footer-redes-destacado .footer-mensaje {
      font-size: 0.92rem !important;
      margin-bottom: 14px !important;
    }
    .footer-redes-destacado .footer-lista-iconos {
      gap: 14px !important;
    }
  }
`;

const ESTILOS_DESTACADO = {
  footer: {
    background: 'linear-gradient(135deg, #872434 0%, #5e1926 100%)',
    color: '#FFFFFF',
    padding: '28px 24px 18px',
  },
  contenedor: { maxWidth: '640px', margin: '0 auto', textAlign: 'center' },
  kicker: {
    display: 'inline-block',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.75)',
    marginBottom: '8px',
  },
  mensaje: { fontSize: '1.05rem', fontWeight: 300, marginBottom: '20px', color: '#FFFFFF' },
  listaIconos: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
    marginBottom: '4px',
    padding: 0,
    listStyle: 'none',
  },
  enlaceIcono: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    color: '#FFFFFF',
    textDecoration: 'none',
    width: '84px',
  },
  insignia: {
    width: '58px',
    height: '58px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,255,255,0.35)',
    transition: 'transform .2s ease, background-color .2s ease',
  },
  etiqueta: { fontSize: '0.72rem', color: 'rgba(255,255,255,0.9)', wordBreak: 'break-word' },
  version: {
    textAlign: 'center',
    marginTop: '16px',
    paddingTop: '10px',
    borderTop: '1px solid rgba(255,255,255,0.18)',
  },
};

// Footer "destacado": diseño propio para cuando la única sección con datos
// es Redes Sociales (hoy, CR). Se activa por la forma de los datos, no por
// el país — si mañana CR agrega más secciones, deja de aplicar solo y se
// usa FooterCompleto automáticamente.
function FooterRedesSocialesDestacado({ web, redesSociales, mensaje, versionApp }) {
  // El sitio web no es una "red social", pero en este layout se muestra en
  // la misma fila de íconos por simplicidad visual (mismo componente,
  // mismo tamaño) — el dato sigue viviendo aparte en footerDatosPorPais.js.
  const enlaces = web
    ? [{ tipo: 'web', usuario: web.texto, url: web.url }, ...redesSociales]
    : redesSociales;

  return (
    <footer className="footer-redes-destacado" style={ESTILOS_DESTACADO.footer}>
      <style>{ESTILO_DESTACADO_RESPONSIVE}</style>
      <div style={ESTILOS_DESTACADO.contenedor}>
        <span style={ESTILOS_DESTACADO.kicker}>{TITULOS_SECCION.redesSociales}</span>
        <p className="footer-mensaje" style={ESTILOS_DESTACADO.mensaje}>{mensaje}</p>
        <ul className="footer-lista-iconos" style={ESTILOS_DESTACADO.listaIconos}>
          {enlaces.map((red, index) => (
            <li key={index}>
              <a href={red.url} target="_blank" rel="noopener noreferrer" style={ESTILOS_DESTACADO.enlaceIcono} title={red.usuario}>
                <span className="footer-icono-insignia" style={ESTILOS_DESTACADO.insignia}>
                  <IconoRedSocial tipo={red.tipo} size="26px" />
                </span>
                <span style={ESTILOS_DESTACADO.etiqueta}>{red.usuario}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div style={ESTILOS_DESTACADO.version}>
        <h6 style={{ margin: 0 }}><strong>{textoVersion(versionApp)}</strong></h6>
      </div>
    </footer>
  );
}

// Si el país tiene "contactenosApi" configurado (ver footerDatosPorPais.js),
// intenta traer datos en vivo del backend y los superpone sobre el fallback
// estático. Si el país no lo tiene, o la API no devuelve nada todavía
// (204, red caída, timeout), se usa el fallback estático sin cambios.
//
// El código de aseguradora usado en la consulta prioriza el de la sesión
// (AseguradoraContext, real: viene de la póliza que el cliente seleccionó)
// sobre el fijo/público de footerDatosPorPais.js. Al depender de ese valor
// de contexto en el arreglo de dependencias del efecto, este hook se
// re-ejecuta solo cuando el cliente inicia sesión, cambia de póliza (otra
// aseguradora) o cierra sesión — no hace falta un reload para que el
// Footer se actualice.
function useDatosFooter(datosBase) {
  const { codigoAseguradora: codigoAseguradoraSesion } = useAseguradora();
  const contactenosApi = datosBase && datosBase.contactenosApi;
  const idPais = contactenosApi && contactenosApi.idPais;
  const codigoAseguradora = codigoAseguradoraSesion || (contactenosApi && contactenosApi.codigoAseguradora);
  const [datos, setDatos] = useState(datosBase);
  const [cargando, setCargando] = useState(Boolean(idPais));

  useEffect(() => {
    if (!idPais) {
      setDatos(datosBase);
      setCargando(false);
      return;
    }

    let activo = true;
    setCargando(true);
    obtenerContactenosPorIdPais(idPais, codigoAseguradora).then((parametros) => {
      if (!activo) return;
      // "servicioCliente" (cabina/correo) solo se arma si el código viene de
      // una sesión real con póliza seleccionada — no del público/fijo.
      const datosApi = construirDatosFooterDesdeContactenos(parametros, {
        incluirServicioCliente: Boolean(codigoAseguradoraSesion),
      });
      setDatos({ ...datosBase, ...datosApi });
      setCargando(false);
    });

    return () => {
      activo = false;
    };
    // codigoAseguradoraSesion se incluye aparte de "codigoAseguradora": si la
    // aseguradora de sesión coincide con la pública (mismo código), la
    // cadena final no cambia, pero SÍ debe cambiar "incluirServicioCliente"
    // — sin esta dependencia el efecto no se reejecutaría en ese caso.
  }, [datosBase, idPais, codigoAseguradora, codigoAseguradoraSesion]);

  return { datos, cargando };
}

export default function Footer({ versionApp }) {
  const { pais, cargando: cargandoPais } = usePais();
  const datosBase = FOOTER_DATOS_POR_PAIS[pais];
  const { datos, cargando: cargandoContactenos } = useDatosFooter(datosBase);

  if (cargandoPais || cargandoContactenos || !datos) {
    return null;
  }

  const secciones = ORDEN_SECCIONES.filter((clave) => seccionTieneContenido(datos, clave));

  if (secciones.length === 0) {
    return null;
  }

  const soloRedesSociales = secciones.length === 1 && secciones[0] === 'redesSociales';

  if (soloRedesSociales) {
    return (
      <FooterRedesSocialesDestacado
        web={datos.web}
        redesSociales={datos.redesSociales}
        mensaje={datos.mensajeRedesSociales || MENSAJE_REDES_POR_DEFECTO}
        versionApp={versionApp}
      />
    );
  }

  return <FooterCompleto secciones={secciones} datos={datos} versionApp={versionApp} />;
}
